import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { FiPlus, FiEdit2, FiTrash2, FiSearch, FiPackage } from 'react-icons/fi';
import { stockInAPI, productsAPI } from '../../services/api';
import { useAuth } from '../../context/AuthContext';
import StockInForm from './StockInForm';

const StockInList = () => {
  const { hasPermission } = useAuth();
  const [records, setRecords] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({ page: 1, limit: 10, total: 0, pages: 0 });
  const [filters, setFilters] = useState({
    search: '',
    product_id: '',
    location: '',
    date_from: '',
    date_to: ''
  });
  const [showForm, setShowForm] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  useEffect(() => {
    fetchProducts();
  }, []);

  useEffect(() => {
    fetchRecords();
  }, [pagination.page, filters]);

  const fetchProducts = async () => {
    try {
      const response = await productsAPI.getAll({ limit: 1000, status: 'active' });
      setProducts(response.data.data);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  const fetchRecords = async () => {
    try {
      setLoading(true);
      const response = await stockInAPI.getAll({
        page: pagination.page,
        limit: pagination.limit,
        ...filters
      });
      setRecords(response.data.data);
      console.log("Check response:", response.data)
      setPagination({
        ...pagination,
        total: response.data.pagination.total,
        pages: response.data.pagination.pages
      });
    } catch (error) {
      console.error('Error fetching stock-in records:', error);
    } finally {
      setLoading(false);
    }
  };

  // const handleFilterChange = (e) => {
  //   const { name, value } = e.target;
  //   setFilters({ ...filters, [name]: value });
  //   console.log(filters);

  //   setPagination({ ...pagination, page: 1 });
  // };
  
  
const handleFilterChange = (e) => {
  const { name, value } = e.target;

  const updatedFilters = { ...filters, [name]: value };
  setFilters(updatedFilters);

  console.log('Updated Filters:', updatedFilters); // ✅
};

  const handleAdd = () => {
    setSelectedRecord(null);
    setShowForm(true);
  };

  const handleEdit = (record) => {
    setSelectedRecord(record);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this stock-in record? This will reverse the stock update.')) {
      return;
    }

    try {
      await stockInAPI.delete(id);
      toast.success('Stock-in record deleted successfully');
      fetchRecords();
    } catch (error) {
      console.error('Error deleting record:', error);
    }
  };

  const handleFormClose = () => {
    setShowForm(false);
    setSelectedRecord(null);
  };

  const handleFormSuccess = () => {
    fetchRecords();
    handleFormClose();
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('en-IN');
  };

  return (
    <div className="p-6">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Stock In</h1>
          <p className="text-gray-600 mt-1">Add inventory to locations</p>
        </div>
        {hasPermission('stock', 'add') && (
          <button
            onClick={handleAdd}
            className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
          >
            <FiPlus /> 
            <span className="hidden md:inline">Add Stock In</span>
          </button>
        )}
      </div>

      {/* Filters */}
      <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
          <div className="relative lg:col-span-2">
            <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              name="search"
              placeholder="Search..."
              value={filters.search}
              onChange={handleFilterChange}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          {/* <select
            name="product_id"
            value={filters.product_id}
            onChange={handleFilterChange}
            className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">All Products</option>
            {products.map((product) => (
              <option key={product.id} value={product.id}>{product.name}</option>
            ))}
          </select> */}
          <select
            name="location"
            value={filters.location}
            onChange={handleFilterChange}
            className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">All Locations</option>
            <option value="Office">Office</option>
            <option value="Godown">Godown</option>
            <option value="Factory">Factory</option>
          </select>
          <input
            type="date"
            name="date_from"
            value={filters.date_from}
            onChange={handleFilterChange}
            placeholder="From Date"
            className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <input
            type="date"
            name="date_to"
            value={filters.date_to}
            onChange={handleFilterChange}
            placeholder="To Date"
            className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>

      {/* Table */}
      <div className="bg-white rounded-lg shadow-sm overflow-hidden">
        {loading ? (
          <div className="text-center py-12">
            <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
            <p className="mt-2 text-gray-600">Loading...</p>
          </div>
        ) : records.length === 0 ? (
          <div className="text-center py-12">
            <FiPackage className="mx-auto text-gray-400 mb-4" size={48} />
            <p className="text-gray-600">No stock-in records found</p>
          </div>
        ) : (
          <>
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-50 border-b">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Product Code</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Quantity</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Location</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Supplier</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Invoice No.</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Unit Price</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Created By</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {records.map((record) => (
                    <tr key={record.id} className="hover:bg-gray-50">
                      
                      <td className="px-6 py-4">
                        {/* <div className="font-medium text-gray-900">{record.product_name}</div> */}
                        <div className=" text-gray-500">{record.item_code}</div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="font-medium text-gray-900">{record.quantity} {record.unit}</div>
                      </td>
                      <td className="px-6 py-4">
                        <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                          record.location === 'Office' ? 'bg-blue-100 text-blue-800' :
                          record.location === 'Godown' ? 'bg-green-100 text-green-800' :
                          'bg-purple-100 text-purple-800'
                        }`}>
                          {record.location}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <div className="text-gray-900">{record.supplier_name || '-'}</div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="text-gray-900">{record.invoice_number || '-'}</div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="text-gray-900">₹{parseFloat(record.unit_price).toFixed(2)}</div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="text-gray-600">{record.created_by_name}</div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="text-gray-900">{formatDate(record.invoice_date)}</div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex gap-2">
                          {hasPermission('stock', 'edit') && (
                            <button
                              onClick={() => handleEdit(record)}
                              className="text-blue-600 hover:text-blue-800"
                            >
                              <FiEdit2 size={18} />
                            </button>
                          )}
                          {hasPermission('stock', 'delete') && (
                            <button
                              onClick={() => handleDelete(record.id)}
                              className="text-red-600 hover:text-red-800"
                            >
                              <FiTrash2 size={18} />
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {pagination.pages > 1 && (
              <div className="px-6 py-4 border-t flex items-center justify-between">
                <div className="text-sm text-gray-600">
                  Showing {(pagination.page - 1) * pagination.limit + 1} to{' '}
                  {Math.min(pagination.page * pagination.limit, pagination.total)} of {pagination.total} results
                </div>
                <div className="flex gap-2">
                  <button
                    onClick={() => setPagination({ ...pagination, page: pagination.page - 1 })}
                    disabled={pagination.page === 1}
                    className="px-4 py-2 border rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
                  >
                    Previous
                  </button>
                  <button
                    onClick={() => setPagination({ ...pagination, page: pagination.page + 1 })}
                    disabled={pagination.page === pagination.pages}
                    className="px-4 py-2 border rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {/* Form Modal */}
      {showForm && (
        <StockInForm
          record={selectedRecord}
          onClose={handleFormClose}
          onSuccess={handleFormSuccess}
        />
      )}
    </div>
  );
};

export default StockInList;
